import { EntityType } from '@panaya/ai-chat/shared';

/**
 * Logs the mapped paths one entity's data lacks, so a field the agent renamed or dropped is visible in the console instead of
 * an empty field nobody notices. Called once per conversion of an entity's data, not on every poll.
 */
export function reportMissingPaths(entityType: EntityType, entityId: number, paths: string[]): void {
    if (paths.length === 0) {
        return;
    }

    console.warn(`Canvas: the ${entityType} entity ${entityId} has no value at the mapped paths: ${paths.join(', ')}.`);
}

/** Logs that an entity type has no registered mapping, so its panels show a title and nothing else. */
export function reportUnmappedEntityType(entityType: EntityType, entityId: number): void {
    console.warn(`Canvas: no mapping is registered for ${entityType}, so the entity ${entityId} shows only its title.`);
}
